import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';
import { GetSegmentChangeHistoryResponse } from 'types/segments/segments.types';
import * as segmentChangeHistoryService from '../../services/segmentChangeHistoryService/segmentChangeHistoryService';
import {
  getSegmentChangeHistoryFailure,
  getSegmentChangeHistorySuccess,
} from './segmentChangeHistory.action';
import {
  GET_SEGMENT_CHANGE_HISTORY_REQUEST,
  GetSegmentChangeHistoryRequestAction,
} from './segmentChangeHistory.types';

function* getSegmentChangeHistoryWorker(
  action: GetSegmentChangeHistoryRequestAction
): SagaIterator {
  try {
    const response: GetSegmentChangeHistoryResponse = yield call(
      segmentChangeHistoryService.getSegmentChangeHistory,
      action.payload
    );
    yield put(getSegmentChangeHistorySuccess(response));
  } catch (error: any) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      'Failed to fetch segment change history';
    yield put(getSegmentChangeHistoryFailure(errorMessage));
  }
}

export function* segmentChangeHistorySaga(): SagaIterator {
  yield takeLatest(
    GET_SEGMENT_CHANGE_HISTORY_REQUEST,
    getSegmentChangeHistoryWorker
  );
}
